import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useContext, useState } from 'react';
import { Button, Icon, Modal as SemanticUiModal } from 'semantic-ui-react';
import { CheckoutContext } from '../../Checkout.context';
import './Modal.css';
var defaultProps = {
  trigger: /*#__PURE__*/React.createElement("div", {
    className: "payment-checkout-button-container"
  }, /*#__PURE__*/React.createElement(Button, {
    primary: true
  }, "Checkout"))
};
export default function Modal(_ref) {
  var children = _ref.children,
    trigger = _ref.trigger;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showModal = _useState2[0],
    setShowModal = _useState2[1];
  var _useContext = useContext(CheckoutContext),
    checkout = _useContext.checkout;
  var resetCheckout = checkout.resetCheckout;
  function onOpen() {
    resetCheckout();
    setShowModal(true);
  }
  function onClose() {
    setShowModal(false);
  }
  return /*#__PURE__*/React.createElement(SemanticUiModal, {
    onClose: onClose,
    onOpen: onOpen,
    open: showModal,
    dimmer: "inverted",
    closeOnDimmerClick: false,
    trigger: trigger,
    className: "payment-checkout-modal"
  }, /*#__PURE__*/React.createElement(SemanticUiModal.Header, null, /*#__PURE__*/React.createElement("div", null, "Checkout"), /*#__PURE__*/React.createElement(Icon, {
    name: "close",
    onClick: function onClick() {
      setShowModal(false);
    }
  })), /*#__PURE__*/React.createElement(SemanticUiModal.Content, null, children));
}
Modal.defaultProps = defaultProps;